<template>
  <div class="page-container indications-page">
    <portal to="page-name">Solicitantes / Indicações</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Solicitantes / Indicações</h1>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column form-group">
            <div class="input-group">
              <input type="text" id="filter-search" name="filter-search" class="form-input"
                     v-model="filter.search" maxlength="100" autocomplete="nope" v-focus>
              <button class="btn btn-neutral btn-action input-group-btn btn-icon" tabindex="-1">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
            </div>
          </div>
        </div>
        <div class="loading loading-lg mt-2" v-if="loading" />
        <template v-else>
          <div class="empty mt-2" v-if="data.items && data.items.length === 0">
            <div class="empty-icon">
              <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
            </div>
            <p class="empty-title h5">Indicações</p>
            <p class="empty-subtitle">
              Nenhum registro encontrado. Verifique os filtros para realizar novas buscas
            </p>
          </div>
          <table class="table table-striped table-hover" v-else>
            <thead>
            <tr>
              <th class="hide-sm" style="width: 40px">#</th>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Conselho</th>
              <th>Especialidade</th>
              <th/>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in data.items" :key="i">
              <td class="hide-sm">{{ i + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ getTypeName(item.type) }}</td>
              <td>{{ getCouncil(item.council) }}</td>
              <td>{{ getSpecialty(item.specialty) }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-action btn-icon btn-error"
                        :class="{loading: removing && idx === i}"
                        :disabled="removing"
                >
                  <fa-icon :icon="['fal', 'times']" @click="remove(item.id, i)"/>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
      <div class="card-footer text-center" v-if="data.items.length > 0">
        <button
          v-if="data.hasMore && !loading"
          class="btn btn-primary btn-fixed-width"
          @click="loadMore"
          :disabled="loadingMore"
          :class="{ loading: loadingMore }"
        >Carregar mais</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      filter: {
        search: '',
      },
      idx: null,
      debounceTimeout: null,
      loading: false,
      loadingMore: false,
      removing: false,
      data: {
        items: [],
        hasMore: false,
        limit: 100,
        offset: 0,
      },
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    filter: {
      handler() {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.reload, 1000);
      },
      deep: true,
    },
  },
  methods: {
    async reload() {
      this.data.offset = 0;
      await this.load();
    },
    async loadMore() {
      this.data.offset += this.data.limit;
      await this.load();
    },
    load() {
      const firstData = this.data.offset === 0;

      if (firstData) {
        this.loading = true;
      } else {
        this.loadingMore = true;
      }

      const params = {
        limit: this.data.limit,
        offset: this.data.offset,
      };

      if (this.filter.search.trim().length > 0) {
        params.search = this.filter.search;
      }

      return this.$http.get('/appointment-indications', { params })
        .then(({ data }) => {
          this.data.hasMore = data.hasMore;
          this.data.items = firstData ? data.items : [...this.data.items, ...data.items];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadingMore = false;
        });
    },
    getCouncil(council) {
      if (!council?.record) {
        return null;
      }
      return `${council.name}-${council.state} ${council.record}`;
    },
    getSpecialty(specialty) {
      if (!specialty) {
        return null;
      }
      return specialty.name;
    },
    getTypeName(type) {
      if (type === 'professional') {
        return 'Profissional';
      } if (type === 'collaborator') {
        return 'Colaborador';
      } if (type === 'partner') {
        return 'Parceiro';
      }
      return 'Paciente';
    },
    remove(id, idx) {
      this.removing = true;
      this.idx = idx;
      return this.$http.delete(`/appointment-indications/${id}`)
        .then(() => {
          this.data.items.splice(idx, 1);
        })
        .catch(() => {})
        .finally(() => {
          this.removing = false;
        });
    },
  },
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
  .indications-page {
    .btn-fixed-width {
      font-size: $font-size-lg;
      height: 2.2rem;
      margin: $layout-spacing-lg 0;
      width: 11rem;
    }
  }
</style>
